import React, { useContext } from "react";
import CustomFormat from "./Steps/CustomFormat";
import SkuPicker from "./Steps/SkuPicker/SkuPicker";
import ExtraOptions from "./Steps/ExtraOptions";
import { ProductOptionStepsContext } from "../../Providers/ProductOptionStepsProvider";
import QuantityOptions from "./Steps/QuantityOptions/QuantityOptions";
import Verspreiden from "./Steps/Verspreiden";
import Overview from "./Steps/Overview/Overview";
import PrintInside from "./Steps/PrintInside/PrintInside";
import NumberOfSheets from "./Steps/NumberOfSheets";

const ProductOptionStep = ({ step }) => {

    const { onOpenModal, } = useContext(ProductOptionStepsContext);
    switch (step.id) {
        case "overview":
            return (
                <Overview
                    step={step}
                />
            );
        case "qty":
            return (
                <QuantityOptions
                    type={step.id}
                />
            );
        case "foto_format":
            return (
                <CustomFormat
                    step={step}
                    onOpenInfoModal={() => onOpenModal(step.id)}
                />
            );
        case "print_inside":
            return (
                <PrintInside step={step}
                onOpenInfoModal={() => onOpenModal(step.id)} />

            );
        case "custom_format":
            return (
                <CustomFormat
                    step={step}
                    onOpenInfoModal={() => onOpenModal(step.id)}
                />
            );
        case "inputvellen":
            return (
                <NumberOfSheets
                    step={step}
                    onOpenInfoModal={() => onOpenModal(step.id)}
                />
            );
        case "verspreidgebied":
            return (
                <Verspreiden
                    step={step}
                    onOpenInfoModal={() => onOpenModal(step.id)}
                />
            );
        default:
            return (
                <SkuPicker
                    step={step}
                />
            );
    }
};

export default ProductOptionStep;
